import React, { useEffect, useState } from "react";
import { Alert } from "antd";
import { supabase } from "../lib/supabase";
import type { AnnouncementBanner } from "../types/announcementBanner";
import styled from "@emotion/styled";

const Wrapper = styled.div`
  width: 100%;
  & .ant-alert {
    margin-bottom: 0;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
  & .ant-alert + .ant-alert {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
`;

export const AnnouncementBanners: React.FC = () => {
  const [banners, setBanners] = useState<AnnouncementBanner[]>([]);

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase
        .from("announcement_banners")
        .select("id, title, subject, style, is_live, created_at, updated_at")
        .eq("is_live", true)
        .order("created_at", { ascending: true });

      setBanners((data as AnnouncementBanner[]) ?? []);
    };
    load();

    // No Realtime subscription: banners are low-churn. Load on mount and when
    // admin dispatches "announcement-banners-refresh" after saving.
    const onRefresh = () => load();
    window.addEventListener("announcement-banners-refresh", onRefresh);

    return () => {
      window.removeEventListener("announcement-banners-refresh", onRefresh);
    };
  }, []);

  if (banners.length === 0) return null;

  return (
    <Wrapper>
      {banners.map((b) => (
        <Alert
          key={b.id}
          type={b.style}
          message={b.title}
          description={b.subject || undefined}
          banner
          showIcon
        />
      ))}
    </Wrapper>
  );
};
